import React from 'react';

const PROGRESS = '#0043CE'; // fill thanh tiến độ
const TRACK = '#E0E0E0';

// vị trí 4 chấm trên thanh (lấy từ Figma: 37/80/160/250px trên bar ~328px)
const DOTS = [11, 24, 49, 76];

/**
 * Thanh tiến độ theo đúng Figma: cao 12px, bo 64px + 4 chấm đổi màu theo % đã đạt.
 * Chấm nằm trên phần đã đạt (fill) → trắng; trên track → xám đậm.
 */
export const DottedProgress: React.FC<{ pct: number; className?: string }> = ({
  pct,
  className = '',
}) => (
  <div className={`relative h-[12px] w-full ${className}`}>
    <div
      className="absolute inset-0 rounded-[64px] overflow-hidden"
      style={{ background: TRACK }}
    >
      <div
        className="h-full rounded-[64px]"
        style={{ width: `${pct}%`, background: PROGRESS }}
      />
    </div>
    {DOTS.map((left) => (
      <span
        key={left}
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
        style={{
          left: `${left}%`,
          background: left <= pct ? 'rgba(255,255,255,0.9)' : '#A8A8A8',
        }}
      />
    ))}
  </div>
);

export default DottedProgress;
